import { prefix } from './actions';

export const loading = state => state[prefix].loading;
export const results = state => state[prefix].results;
export const resultsAmount = state => state[prefix].resultsAmount;
export const resultsComposed = state => state[prefix].resultsComposed;
export const searchedStr = state => state[prefix].searchedStr;
